<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Nuevo Contrato')"
        v-loading="loading" element-loading-text="Cargando..."
        element-loading-background="rgba(255, 255, 255)">
        <br>
        <el-row :gutter="20">
          <el-col :md="12">
            <h2>{{$t('Asignación de Revisores.')}}</h2>
          </el-col>
          <el-col :md="12">
            <StepsContrato v-bind:step="2"></StepsContrato>
          </el-col>
        </el-row>
        <div>
          <h3>{{$t('Asignación de revisores')}}</h3>

          <el-form :model="contractPeople" label-position="top">
            <el-row :gutter="20" v-if="newContract.tipo_contrato === 'Contratista'">
              <!-- Personas contratista -->
              <h4>Personas Contratistas</h4>
              <!-- Coordinador Contratista-->
              <el-col :md="12" v-if="newContract.tipo_contrato === 'Contratista'">
                <el-form-item :label="$t('Coordinador Contratista')">
                  <PeopleSelect
                    :model.sync="contractPeople.contractor_coordinator[0]"
                    :users="companyUsersWithRole('contractor_coordinator', 'Contratista')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('contractor_coordinator')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item :label="$t('Asesor SSO Contratista 1')">
                  <PeopleSelect
                    :model.sync="contractPeople.contractor_hse[0]"
                    :users="companyUsersWithRole('contractor_hse', 'Contratista')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('contractor_hse')"
                    icon="el-icon-plus">
                      {{$t('Crear')}}
                  </el-button>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item :label="$t('Asesor SSO Contratista 2')">
                  <PeopleSelect
                    :model.sync="contractPeople.contractor_hse[1]"
                    :users="companyUsersWithRole('contractor_hse', 'Contratista')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('contractor_hse')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item :label="$t('Administrador de Contrato')">
                  <PeopleSelect
                    :model.sync="contractPeople.administrator[0]"
                    :users="companyUsersWithRole('administrator', 'Contratista')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('administrator')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- Personas BHP -->
            <h4>Personas de la Compañia</h4>
            <el-row :gutter="20">
              <el-col :md="24" v-if="newContract.tipo_contrato === 'Propio'">
                <el-form-item :label="$t('Coordinador')">
                  <PeopleSelect
                    :model.sync="contractPeople.coordinator[0]"
                    :users="bhpUsersWithRole('coordinator')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('coordinator')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>

              <!-- Salud -->
              <el-col :md="12">
                <el-form-item :label="$t('Especialista Salud 1')">
                  <PeopleSelect
                    :model.sync="contractPeople.health[0]"
                    :users="bhpUsersWithRole('health')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('health')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item :label="$t('Especialista Salud 2')">
                  <PeopleSelect
                    :model.sync="contractPeople.health[1]"
                    :users="bhpUsersWithRole('health')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('health')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>
              <!-- Seguridad -->
              <el-col :md="12">
                <el-form-item :label="$t('Especialista Seguridad 1')">
                  <PeopleSelect
                    :model.sync="contractPeople.safety[0]"
                    :users="bhpUsersWithRole('safety')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('safety')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item :label="$t('Especialista Seguridad 2')">
                  <PeopleSelect
                    :model.sync="contractPeople.safety[1]"
                    :users="bhpUsersWithRole('safety')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('safety')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>
              <!-- Medioambiente -->
              <el-col :md="12">
                <el-form-item :label="$t('Especialista Medioambiente 1')">
                  <PeopleSelect
                    :model.sync="contractPeople.environment[0]"
                    :users="bhpUsersWithRole('environment')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('environment')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item :label="$t('Especialista Medioambiente 2')">
                  <PeopleSelect
                    :model.sync="contractPeople.environment[1]"
                    :users="bhpUsersWithRole('environment')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('environment')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>


              <el-col :md="12" v-if="newContract.tipo_contrato === 'Contratista' || newContract.tipo_contrato === 'Subcontratista'">
                <el-form-item :label="$t('Dueño de Contrato')">
                  <PeopleSelect
                    :model.sync="contractPeople.owner[0]"
                    :users="bhpUsersWithRole('owner')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('owner')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item :label="$t('Especialista de Riesgo')">
                  <PeopleSelect
                    :model.sync="contractPeople.risk[0]"
                    :users="bhpUsersWithRole('risk')" />
                  <el-button
                    size="mini"
                    @click="openDialogAddUser('risk')"
                    icon="el-icon-plus">
                      {{ $t('Crear') }}
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <h4>
            {{$t('Perfiles relacionados al área')}}
            "{{ this.area.nombre }}"
            <span v-if="this.area.area_padre">
              , {{$t('perteneciente a área')}} "{{ this.area.area_padre.nombre }}"
            </span>
          </h4>
          <el-row :gutter="20">
            <el-col :md="8">
              <div class="titleProfilesArea">{{$t('Superintendente de Área')}}</div>
              <div class="textProfilesArea">{{ areaSuperintendent }}</div>
            </el-col>
            <el-col :md="8">
              <div class="titleProfilesArea">{{$t('Gerente de Área')}}</div>
              <div class="textProfilesArea">{{ areaManager }}</div>
            </el-col>
            <el-col :md="8">
              <div class="titleProfilesArea">{{$t('Gerente de Área Superior')}}</div>
              <div class="textProfilesArea">{{ areaSuperiorManager }}</div>
            </el-col>
          </el-row>
        </div>
        <br><br><br>
        <el-col :span="24" class="centrar">
          <el-button-group>
            <el-button type="primary" @click="backStep()" icon="el-icon-arrow-left">Regresar</el-button>
            <el-button :loading="isLoading" @click="nextStep()" type="primary">{{$t('Finalizar')}}<i class="el-icon-arrow-right el-icon-right"></i></el-button>
          </el-button-group>
        </el-col>
        <br><br>
      </el-tab-pane>
    </el-tabs>


    <!-- Dialog -->
    <DialogAddUser
      :user="user"
      :visibleSync="dialogAddUser"
      :action="action"
      :findUser="findUser"
      :onCancel="handleClose"
      :onAcept="createUpdateUser"/>

  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import StepsContrato from '@/components/contracts/StepsContrato.vue';
import PeopleSelect from '@/components/contracts/PeopleSelect.vue';
import DialogAddUser from '@/components/dialogCreateUserRol.vue';

export default {
  name: 'wizard',
  components: {
    StepsContrato,
    PeopleSelect,
    DialogAddUser,
  },
  data() {
    return {
      loading: false,
      dialogProfile: false,
      isLoading: false,
      action: 'update',
      findUser: false,
      newPermission: [],
      dialogAddUser: false,
      contractPeople: {
        contractor_coordinator: [''],
        contractor_hse: ['', ''],
        administrator: [''],
        coordinator: [''],
        owner: [''],
        risk: [''],
        hse: ['', ''],
        health: ['', ''],
        safety: ['', ''],
        environment: ['', ''],
      },
      user: {},
      bhpProfiles: {
        hse: 'Asesor SSO',
        health: this.$t('Especialista de Salud'),
        safety: this.$t('Especialista de Seguridad'),
        environment: this.$t('Especialista de Medioambiente'),
        contractor_hse: this.$t('Asesor SSO Contratista'),
        owner: this.$t('Dueño de Contrato'),
        contract_owner: this.$t('Dueño de Contrato'),
        risk: this.$t('Especialista de Riesgo'),
        administrator: this.$t('Administrador de Contrato'),
        contractor_coordinator: this.$t('Coordinador Contratista'),
        coordinator: this.$t('Coordinador'),
        manager: this.$t('Gerente de Área'),
        super: this.$t('Superintendente de Área'),
        general_manager: this.$t('Gerente General'),
      },
    };
  },
  async created() {
    if (Object.keys(this.$store.getters.newContract).length === 0) {
      this.$router.push({ name: 'contractCreateStep1' });
    }
    await this.getUsersFaena(this.$store.getters.role.faena_id);
  },
  computed: {
    ...mapGetters({
      usersFaena: 'usersFaena',
      areas: 'areas',
      newContract: 'newContract',
    }),
    area() {
      return this.areas.find(area => area._id === this.newContract.area_id);
    },
    areaSuperintendent() {
      if (!this.area.super || !this.area.super.nombre) return '---';
      return `${this.area.super.nombre} ${this.area.super.apellido}`;
    },
    areaManager() {
      if (!this.area.gerente || !this.area.gerente.nombre) return '---';
      return `${this.area.gerente.nombre} ${this.area.gerente.apellido}`;
    },
    areaSuperiorManager() {
      if (!this.area.area_padre) return '---';
      if (!this.area.area_padre.gerente || !this.area.area_padre.gerente.nombre) return '---';
      return `${this.area.area_padre.gerente.nombre} ${this.area.area_padre.gerente.apellido}`;
    },
  },
  watch: {
    'user.rut': function () { this.debounceInput(); },
  },
  methods: {
    ...mapActions([
      'getUsersFaena',
      'setNewContract',
      'saveContract',
    ]),
    backStep() {
      this.$router.push({name: 'contractCreateStep2'});
    },
    async nextStep() {
      // this.isLoading = true
      this.loading = true;
      let valid = true;
      valid = this.contractPeopleValidation();
      console.log(valid);
      // Registrar cambios en local si es válido
      if (valid) {
        const auxContract = Object.assign(
          {},
          this.newContract,
          { revisores: this.contractPeople },
        );
        localStorage.setItem('newContract', JSON.stringify(auxContract));
        this.setNewContract(auxContract);
        const response = await this.saveContract();
        if (response.success) {
          this.loading = false;
          this.$router.push({ name: 'listContracts' });
        } else {
          console.log('error al guardar');
          this.loading = false;
        }
      } else {
        this.$message({
          message: 'Atención, Para continuar debes completar todos los campos requeridos.',
          type: 'warning',
        });
        this.loading = false;
      }
    },
    contractPeopleValidation() {
      const nc = this.newContract;
      const cp = this.contractPeople;
      if (true
          && !cp.health.includes('')
          && !cp.safety.includes('')
          && !cp.environment.includes('')
          && !cp.risk.includes('')) {
        if (true
            && nc.tipo_contrato === 'Propio'
            && !cp.coordinator.includes('')) { return true; }
        if (nc.tipo_contrato === 'Contratista' || nc.tipo_contrato === 'Subcontratista') {
          if (true
              && !cp.contractor_coordinator.includes('')
              && !cp.contractor_hse.includes('')
              && !cp.administrator.includes('')
              && !cp.owner.includes('')) { return true; }
        }
      }
      return false;
    },
    bhpUsersWithRole(role) {
      const admins = []; const specifics = []; const others = [];
      this.usersFaena.forEach((user) => {
        if (user.roles.admin) {
          admins.push(user);
        } else if (user.roles.areas
          && user.roles.areas[this.newContract.area_id]
          && user.roles.areas[this.newContract.area_id].includes(role)) {
          specifics.push(user);
        }
        /* } else if (user.roles.areas) {
          Object.keys(user.roles.areas).forEach((a) => {
            if (user.roles.areas[a].includes(role)) {
              others.push(user);
            }
          });
        } */
      });
      return [
        { label: 'Específicos del área', options: specifics },
        { label: 'Otras áreas', options: others },
        { label: 'Administrador Plataforma', options: admins },
      ];
    },
    companyUsersWithRole(role, tipo) {
      const specifics = []; const others = [];
      if (tipo === "Contratista") {
        this.usersFaena.forEach((user) => {
          if (user.roles.empresas
            && user.roles.empresas[this.newContract.empresa_id]) {
            if (user.roles.empresas[this.newContract.empresa_id].includes(role)) {
              specifics.push(user);
            } else {
              others.push(user);
            }
          }
        });
      } else if (tipo === "Subcontratista") {
        this.usersFaena.forEach((user) => {
          if (user.roles.empresas
            && user.roles.empresas[this.newContract.empresa_subcontratista_id]) {
            if (user.roles.empresas[this.newContract.empresa_subcontratista_id].includes(role)) {
              specifics.push(user);
            } else {
              others.push(user);
            }
          }
        });
      }
      return [
        { label: 'Específicos', options: specifics },
        { label: 'Otros', options: others },
      ];
    },
    // Crear usuario
    // --
    debounceInput: _.debounce(function () {
      const userExist = this.$store.getters.usersFaena.find(x => x.rut === this.user.rut);
      if (userExist) {
        this.action = 'update';
        this.user = userExist;
        this.user = {
          _id: userExist._id,
          nombre: userExist.nombre,
          apellido: userExist.apellido,
          rut: userExist.rut,
          email: userExist.email,
          roles: userExist.roles,
        };
      } else {
        axios.get(`/usuarios/by_rut/${this.user.rut}`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }).then((response) => {
          if (response.data.hasOwnProperty('success')) {
            this.findUser = false;
            this.user._id = 'Create';
            this.user.nombre = '';
            this.user.apellido = '';
            this.user.email = '';
            this.user.roles = { admin: false },
            this.action = 'create';
          } else {
            this.findUser = true;
            this.action = 'update';
            this.user._id = response.data._id;
            this.user.nombre = response.data.nombre;
            this.user.apellido = response.data.apellido;
            this.user.rut = response.data.rut;
            this.user.email = response.data.email;
          }
        });
      }
    }, 1500),
    openDialogAddUser(perfil) {
      console.log(perfil);
      this.findUser = false;
      this.user = {
        _id: '',
        nombre: '',
        apellido: '',
        rut: '',
        email: '',
        roles: {
          admin: false,
          areas: {},
          empresas: {},
        },
      };
      this.action = 'create';
      this.perfil = perfil;
      this.newPermission.push(perfil);
      this.dialogAddUser = true;
    },
    async createUpdateUser(action) {
      const auxUser = {
        user: {
          _id: this.user._id,
          nombre: this.user.nombre,
          apellido: this.user.apellido,
          rut: this.user.rut,
          email: this.user.email,
        },
      };
      const auxRoles = {
        faenaId: this.$store.getters.role.faena_id,
        module: 'inventarios',
        permissions: this.user.roles,
      };

      // Crear el usuario o usar existente
      let userId = null;
      let tipo = '';
      let acId = '';

      if (this.perfil === 'contractor_coordinator' || this.perfil === 'contractor_hse' || this.perfil === 'administrator') {
        tipo = 'empresas';
        acId = this.$store.getters.newContract.empresa_id;
      } else {
        tipo = 'areas';
        acId = this.$store.getters.newContract.area_id;
      }

      if (action === 'create') {
        const response = await this.createUser(auxUser, auxRoles);
        if (response.success === true) {
          userId = response.userId;
        }
      } else {
        console.log(this.user._id);
        userId = this.user._id;
      }
      // Asignar Role
      await this.addRoleToUser(this.$store.getters.role.faena_id, userId, 'inventarios', tipo, acId, this.newPermission);
    },
    async createUser(userToCreate, roles) {
      const userCreated = await this.$store.dispatch(
        'createUser',
        userToCreate,
      );
      return userCreated;
    },
    async addRoleToUser(faena, userId, modulo, tipo, acId, roles) {
      const rolesUpdated = await this.$store.dispatch(
        'addRolesToUser',
        Object.assign({}, {
          faenaId: faena, userId, module: modulo, type: tipo, acId, permissions: roles,
        }),
      );
      if (rolesUpdated) {
        await this.$store.dispatch(
          'getUsersFaena',
          this.$store.getters.role.faena_id,
        );
        this.handleClose();
        this.$notify.success({
          title: 'Éxito',
          message: 'Usuario editado exitosamente',
        });
      } else {
        this.$notify.success({
          title: 'Error',
          message: 'No fue posible actualizar roles del usuario',
        });
      }
    },
    handleClose() {
      this.dialogAddUser = false;
      this.user = {};
      this.newPermission = [];
      this.perfil = '';
    },
  },
};
</script>

<style scoped>
.titleProfilesArea {
  color: #606266;
  font-size: 14px;
}
.textProfilesArea {
  margin-top: 10px;
  color: gray;
  font-size: 14px;
}
.centrar {
  text-align: center;
}
</style>
